import { render, staticRenderFns } from "./HistoryArticles.vue?vue&type=template&id=03649987&scoped=true"
import script from "./HistoryArticles.vue?vue&type=script&lang=js"
export * from "./HistoryArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03649987",
  null
  
)

export default component.exports